import { render, staticRenderFns } from "./MaterialRequests.vue?vue&type=template&id=1fa01c0e&scoped=true"
import script from "./MaterialRequests.vue?vue&type=script&lang=js"
export * from "./MaterialRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa01c0e",
  null
  
)

export default component.exports